export default {
  name: 'MaterialSymbolsFilterList'
};